import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(() => ({
  root: {
    // SkeletonTheme renders a div in v2
    // Replace with custom span wrapper
    // https://github.com/dvtng/react-loading-skeleton/issues/46
    "& .react-loading-skeleton": {
      backgroundColor: props => props.color,
      backgroundImage: props => `linear-gradient(
					90deg,
					${props.color},
					${props.disableAnimation ? "transparent" : "rgba(0,0,0,.10)"},
					${props.color}
				)`
    }
  },
  disableAnimation: {
    "& span[style]": {
      animation: "none !important",
      backgroundImage: "none"
    }
  }
}));
export const SkeletonLoader = props => {
  const {
    className,
    count,
    duration,
    width,
    height,
    circle,
    disableAnimation,
    color = "rgba(0,0,0,.10)",
    ...otherProps
  } = props;
  const classes = useStyles({
    color,
    ...props
  });
  const SkeletonProps = {
    count,
    duration,
    width,
    height,
    circle
  };
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classNames("prmbl-skeletonLoader", classes.root, {
      [classes.disableAnimation]: disableAnimation
    }, className),
    role: "progressbar"
  }, otherProps), /*#__PURE__*/React.createElement(Skeleton, SkeletonProps));
};
SkeletonLoader.defaultProps = {
  color: "rgba(0,0,0,.10)"
};
export default SkeletonLoader;